/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_Edit_Pnk_TitleInputs */

const vi_aml_form_edit_pnk_title = /** @type {(inputs: Aml_Form_Edit_Pnk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phiếu nhập kho`)
};

/**

* @param {Aml_Form_Edit_Pnk_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_edit_pnk_title = /** @type {((inputs?: Aml_Form_Edit_Pnk_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_Edit_Pnk_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_edit_pnk_title(inputs)
});